// Pure helpers for the photo drag-and-drop features (Session ADE), shared by the office
// photo surfaces (JobPhotoGallery / JobPhotoUploader / site photos) and the engineer PWA
// photo section. DOM-light and side-effect free so they unit test directly.
import { arrayMove } from "@dnd-kit/sortable";

// Resolve a tile drag into the full new display order (a permutation of 0..count-1), or null for
// a no-op drop. Tile ids are the photos' CURRENT indices as strings ("p0".."pN").
export function photoOrderFromDrag(count: number, activeId: string, overId: string): number[] | null {
  const from = Number.parseInt(activeId.replace(/^p/, ""), 10);
  const to = Number.parseInt(overId.replace(/^p/, ""), 10);
  if (!Number.isInteger(from) || !Number.isInteger(to) || from === to) return null;
  if (from < 0 || to < 0 || from >= count || to >= count) return null;
  return arrayMove(
    Array.from({ length: count }, (_, i) => i),
    from,
    to,
  );
}

// True when a native drag carries files (an OS file drag), so a drop zone only reacts to file
// drags -- never to a dragged image element, text selection, or a dnd-kit pointer drag (which is
// not a native drag at all, so the two gestures can never swallow each other).
export function dragHasFiles(dt: { types?: readonly string[] | DOMStringList } | null): boolean {
  const types = dt?.types;
  if (!types) return false;
  return Array.from(types as readonly string[]).includes("Files");
}
